import {Context} from 'react'
import {typedConnect} from '../../../../../commons/components/runtime-context/connect'
import {RuntimeContext} from '../../../../../commons/components/runtime-context/runtime-context'
import {DetailsPageAppProps} from '../app/interfaces'

export const DetailsPageRuntimeContext: Context<DetailsPageAppProps> = RuntimeContext

export const connect = typedConnect<DetailsPageAppProps>()
